import React from 'react';
import { jobs, SAMPLE_JOBS_NOTICE } from '../../data/jobs';
import { JobCard } from '../jobs/JobCard';
import { SectionHeading } from '../ui/SectionHeading';
import { Button } from '../ui/Button';
import { Reveal } from '../ui/Reveal';
export function FeaturedJobs() {
  const featured = jobs.filter(j => j.featured).slice(0, 3);
  return <section className="bg-ivory py-24 md:py-32" data-id="element-179" data-mp="29wj7h84y1wp2">
      <div className="container-page" data-id="element-180" data-mp="1m5nmatuztzqs">
        <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end" data-id="element-181" data-mp="1m6p0v8b7x4d9">
          <SectionHeading kicker="Opportunities" title="Featured opportunities" intro={SAMPLE_JOBS_NOTICE} data-id="element-182" data-mp="1i5v73yb3gvcg" />
          <Button to="/jobs" variant="outline" arrow className="self-start md:self-auto" data-id="element-183" data-mp="1vxjjm2p99lty">
            View all opportunities
          </Button>
        </div>
        <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-184" data-mp="13f5tyqe2p65y">
          {featured.map((job, i) => <Reveal key={job.id} delay={i * 0.05} className="h-full" data-id="element-185" data-mp="yfjiomht1zzs" data-mpi={i}>
              <JobCard job={job} data-id="element-186" data-mp="13gtik7dwnthr" />
            </Reveal>)}
        </div>
      </div>
    </section>;
}